module.exports = __webpack_public_path__ + "img/zwzp.b624a67e.png";